import { Box, Button, Chip } from "@mui/material";
import PendingReceiptsChip from "../../../../referencias-tablas/clientes/datoscliente/cuentacorriente/recibos/UI/chipDeRecibosPendientes/PendingReceiptsChip";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import FilterListIcon from "@mui/icons-material/FilterList";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { TOOLBAR_ACTIONS } from "../config/TOOLBAR_ACTIONS";
import { TABLE_VARIANTS } from "../config/TABLE_VARIANTS";

const TopToolBar = ({
  variant,
  onAction,
  filtrosActivos = 0,
  cantidadDeRecibosPendientes = 0,
}) => {
  const isCompleto = variant === TABLE_VARIANTS.COMPLETO;
  const isPendiente = variant === TABLE_VARIANTS.PENDIENTE;
  return (
    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
      {isCompleto && (
        <Button
          variant="outlined"
          color="success"
          startIcon={<ReceiptLongIcon />}
          onClick={() => onAction({ type: TOOLBAR_ACTIONS.CREAR_RECIBO })}
          sx={{ borderRadius: 3 }}
        >
          Cargar Recibo
        </Button>
      )}

      {isPendiente && (
        <Button
          variant="outlined"
          color="primary"
          startIcon={<ArrowBackIcon />}
          sx={{ borderRadius: 3 }}
          onClick={() =>
            onAction({ type: TOOLBAR_ACTIONS.DESACTIVAR_SOLO_PENDIENTES })
          }
        >
          Volver a la cuenta corriente
        </Button>
      )}

      <Button
        variant="outlined"
        color="secondary"
        startIcon={<AccountBalanceWalletIcon />}
        onClick={() => onAction({ type: TOOLBAR_ACTIONS.APLICAR_RECIBO })}
        sx={{ borderRadius: 3 }}
      >
        Aplicar Recibo
      </Button>
      {isCompleto && (
        <Button
          variant="outlined"
          color="warning"
          startIcon={<PendingActionsIcon />}
          sx={{ borderRadius: 3 }}
          onClick={() =>
            onAction({ type: TOOLBAR_ACTIONS.VER_SOLO_PENDIENTES })
          }
        >
          Solo Pendientes
        </Button>
      )}
      {isCompleto && (
        <>
          <Button
            variant="outlined"
            startIcon={<FilterListIcon />}
            onClick={() => onAction({ type: TOOLBAR_ACTIONS.APLICAR_FILTROS })}
            sx={{ borderRadius: 3 }}
          >
            Filtros
            {filtrosActivos > 0 && (
              <Chip
                label={filtrosActivos}
                size="small"
                color="primary"
                sx={{ ml: 1, height: 20, fontSize: "0.7rem" }}
              />
            )}
          </Button>
          {filtrosActivos > 0 && (
            <Button
              variant="text"
              size="small"
              color="error"
              startIcon={<CloseIcon />}
              onClick={() =>
                onAction({ type: TOOLBAR_ACTIONS.LIMPIAR_FILTROS })
              }
            >
              Limpiar filtros
            </Button>
          )}
          <PendingReceiptsChip count={cantidadDeRecibosPendientes} />
        </>
      )}
    </Box>
  );
};

export default TopToolBar;
